import { render, staticRenderFns } from "./Produk.vue?vue&type=template&id=6e43c0e2&"
import script from "./Produk.vue?vue&type=script&lang=js&"
export * from "./Produk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports